module.exports = __webpack_public_path__ + "static/media/meals-on-hover.648637e2.png";